import { cx } from '@emotion/css';
import React, { FC } from 'react';

import { useOnClickOutside } from '@/hooks/useOnClickOutside';

import * as styles from './styles';

export type ModalProps = {
  isVisible: boolean;
  isOverlayVisible?: boolean;
  className?: string;
  contentComponent: React.ReactNode;
  footerComponent?: React.ReactNode;
  onOverlayClick?: () => void;
};

const Modal: FC<ModalProps> = (props) => {
  const {
    isVisible,
    isOverlayVisible = true,
    className,
    contentComponent,
    footerComponent,
    onOverlayClick = () => ''
  } = props;
  const containerRef = useOnClickOutside({ onClose: onOverlayClick, useCapture: true });

  return (
    <>
      {isVisible && (
        <>
          {isOverlayVisible && <div className={styles.overlay} />}
          <div className={styles.container}>
            <div ref={containerRef} className={cx(styles.content, className)}>
              <div>{contentComponent}</div>
              <div>{footerComponent}</div>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default Modal;
